import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialog } from '@shared/dialogs/confirmation/confirmation.dialog';
import { firstValueFrom } from 'rxjs';
import { ConfirmDialogArgs } from '@shared/dialogs/confirmation/ConfirmDialogArgs';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private dialog = inject(MatDialog);

  showConfirmDialog(args?: Partial<ConfirmDialogArgs>) {
    const { isClosable, ...confirmDialogData } = { ...args };
    const modalData: ConfirmDialogArgs = {
      title: 'approvalNotification.title',
      subTitle: 'approvalNotification.message',
      actions: {
        confirm: {
          show: true,
        },
        cancel: {
          show: true,
        },
      },
      ...confirmDialogData,
    };
    const dialogRef = this.dialog.open(ConfirmationDialog, {
      width: '500px',
      data: modalData,
      disableClose: !isClosable,
    });

    return firstValueFrom(dialogRef.afterClosed());
  }

  showDeleteConfirmation(args?: Partial<ConfirmDialogArgs>) {
    return this.showConfirmDialog({
      title: 'delete-confirmation.title',
      subTitle: 'delete-confirmation.message',
      ...args,
      actions: {
        ...args?.actions,
        confirm: {
          label: 'shared.delete',
          ...args?.actions?.confirm,
          show: true,
          cssClass: 'danger-button',
          icon: 'delete',
        },
      },
    });
  }
}
